<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import VueSweetalert2 from "vue-sweetalert2";
import ErrorMessage from "../../components/error-message";
export default {
    components: { Layout, PageHeader ,ErrorMessage},
    data() {
        return {
            title: "E Ticket List",
            items: [
                {
                    text: "E Ticket",
                    href: "/",
                },
                {
                    text: "List",
                    active: true,
                },
            ],
            admins: [],
            pin: "",
            bookings: [],
            booking: [],
            passengers:[],
            user_id: "",
            startdate: "",
            enddate: "",
            status:"",
            tickets:[],
            remarks: "",
            errors: null,
            visible:false,
            message:"",
            search1:"",
            search_uname:"",
            search_pnr:"",
            search_trip_type:"",
            search_api_pnr:"",
            search_airline_pnr:"",
            search_reference_key:"",
            search_routes:"",
            search_payment_status:"",
            search_total_passenger:"",
            search_ait:"",
            search_airline:"",
            search_gross_fare:"",
            search_base_fare:"",
            search_total_tax:"",
            search_invoice_fare:"",
            search_commission:"",
            search_markup:"",

        };
    },
    mounted() {
        this.search();
    },
    computed: {
        filteredList() {
            return this.bookings.filter(booking => {
                return booking.search_reference_key.toLowerCase().includes(this.search1.toLowerCase())
                    && (booking.username==null ? '' : booking.username).toLowerCase().includes(this.search_uname.toLowerCase())
                    && (booking.airline_pnr==null ? '' : booking.airline_pnr).toLowerCase().includes(this.search_pnr.toLowerCase())
                    && (booking.api_pnr==null ? '' : booking.api_pnr).toLowerCase().includes(this.search_pnr.toLowerCase())

            })
        }
    },
    methods: {
        onClose(){
            this.visible=false;
        },

        searchFilterFunc2(val) {
            this.search1=val;
        },
        async search() {
            try {
                axios
                    .get("/api/ticket/list", {
                        params: {
                            accessToken: localStorage.getItem("access_tocken"),
                        },
                    })
                    .then((response) => {
                        if (response.data.status) {
                            var res=response.data.data;
                            var i;
                            for (i=0; i<res.length; i++){
                                var j;
                                var all="";
                                for (j=0;j<res[i].flight_segments.length;j++){
                                    if(j<=0){
                                        all+=res[i].flight_segments[j].origin_code+'-'+res[i].flight_segments[j].destination_code;
                                    }
                                    else{
                                        if(res[i].flight_segments[j].origin_code==res[i].flight_segments[j-1].destination_code){
                                            all+='-'+res[i].flight_segments[j].destination_code;
                                        }
                                    }

                                }
                                res[i].routes=all;
                            }
                            this.bookings = res;
                        } else {
                            var str = response.data.message;
                            var jsonParse = JSON.parse(str);
                            this.errorCheck(jsonParse);
                        }
                    })
                    .catch((error) => {
                        console.log(error.message);
                    });
            } catch (err) {
                console.log(err);
            }
        },
        async getBookingDetail(id) {
            try {
                axios
                    .post("/api/flight-booking/details/" + id, {
                        accessToken: localStorage.getItem("access_tocken"),
                    })
                    .then((response) => {
                        if (response.data.status) {
                            this.passengers=response.data.data.passengers;
                            this.booking=response.data.data.booking;
                            this.status=response.data.data.status;
                            this.tickets=response.data.data.tickets;
                        } else {
                            var str = response.data.message;
                            var jsonParse = JSON.parse(str);
                            this.errorCheck(jsonParse);
                        }
                    })
                    .catch((error) => {
                        console.log(error.message);
                    });
            } catch (err) {
                console.log(err);
            }
        },
        errorCheck(obj) {
            if(obj.statusCode == 403){
                this.visible=true;
                this.message="Access Permission Denied";
                this.errors = obj.message;
            }else if (obj.error) {
                this.errors = obj.message;
            } else if (obj.message == "Token has expired") {
                this.$swal.fire({
                    title: 'LogOut!',
                    text: 'Token Has Expired',
                    icon: 'error',
                    toast:'true',
                    position: 'top-end',
                });
                this.$router.push({ name: "logout" });
            } else if (obj.message !== "Token has expired") {
                this.errors = obj.message;
            } else {
                this.flashMessage.show({
                    time: 5000,
                    status: "error",
                    title: "Error",
                    message: "Problem in data save",
                });
            }
        },
    },
};
</script>

<template>
    <Layout @CustomEventInputChangedAll="searchFilterFunc2">
        <PageHeader :title="title" :items="items" />
        <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
        <div class="row">
            <div class="col-lg-12">
                <b-modal
                    id="modal-xl"
                    size="xl"
                    title="Flight Booking Details"
                    title-class="font-18"
                    hide-footer
                >
                    <h4>Booking Info</h4>
                    <div class="table-responsive table-bordered table-sm">
                        <table class="table">
                            <thead>
                            <tr>
                                <th>Key</th>
                                <th> Status</th>
                                <th>Airline Pnr</th>
                                <th>Api Pnr</th>
                                <th>Base Fare</th>
                                <th>Total Tax</th>
                                <th>Gross Fare</th>
                                <th>Ait</th>
                                <th>Markup</th>
                                <th>Commission</th>
                                <th>Invoice Fare</th>
                                <th>Currency</th>
                                <th>Airline</th>
                                <th>Trip Type</th>
                                <th>Payment Status</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>{{booking.search_reference_key}}</td>
                                <td>{{status.status_name}}</td>
                                <td>{{booking.airline_pnr}}</td>
                                <td>{{booking.api_pnr}}</td>
                                <td>{{booking.base_fare}}</td>
                                <td>{{booking.total_tax}}</td>
                                <td>{{booking.gross_fare}}</td>
                                <td>{{booking.ait}}</td>
                                <td>{{booking.markup}}</td>
                                <td>{{booking.commission}}</td>
                                <td>{{booking.invoice_fare}}</td>
                                <td>{{booking.currency}}</td>
                                <td>{{booking.airline}}</td>
                                <td>{{booking.trip_type=='R'?"Round Trip":"One Way"}}</td>
                                <td>{{booking.payment_status}}</td>
                            </tr>
                            </tbody>

                            <!--                                </tbody>-->
                        </table>
                    </div>

                    <h4>Flight Info</h4>
                    <div class="table-responsive table-bordered table-sm">
                        <table class="table mb-0">
                            <thead>
                            <tr>
                                <th>#</th>
                                <!--                          <th>Flight Number</th>-->
                                <th>Origin</th>
                                <th>Departure Time</th>
                                <th>Origin Terminal</th>
                                <th>Destination</th>
                                <th>Arrival Time</th>
                                <th>Destination Terminal</th>
                                <th>Baggage Info</th>
                                <th>Fare Basis</th>
                                <th>Airline</th>
                                <th>Flight Number</th>
                                <th>Travel Duration</th>
                                <th>Booking Class</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(flight,index) in booking.flight_segments"  v-bind:key="index">
                                <th>{{index+1}}</th>
                                <td>{{flight.origin_code}}</td>
                                <td>{{flight.arrival_date |  moment('LLL')}}</td>
                                <td>{{flight.origin_terminal==null ? 'N/A' : flight.origin_terminal}}</td>
                                <td>{{flight.destination_code}}</td>
                                <td>{{flight.destination_date |  moment('LLL')}}</td>
                                <td>{{flight.destination_terminal==null ? 'N/A' : flight.destination_terminal}}</td>
                                <td>{{flight.baggage_information==null ? 'N/A' : flight.baggage_information }}</td>
                                <td>{{flight.fare_basis==null ? 'N/A' : flight.fare_basis}}</td>
                                <td>{{flight.operating_airline_code==null ? 'N/A' : flight.operating_airline_code}}</td>
                                <td>{{flight.operating_flight_number==null ? 'N/A' : flight.operating_flight_number}}</td>
                                <td>{{flight.travel_duration==null ? 'N/A' : flight.travel_duration }}</td>
                                <td>{{flight.booking_class}}</td>
                            </tr>
                            </tbody>

                            <!--                                </tbody>-->
                        </table>
                    </div>
                    <!--                            </table>-->
                    <br>

                    <div>

                        <!--                            <table>-->
                        <h4>Passenger Info</h4>
                        <div class="table-responsive table-bordered table-sm">
                            <table class="table mb-0">
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Passenger Name</th>
                                    <th>Birth Date</th>
                                    <th>Passport No.</th>
                                    <th>Passport Expiry</th>
                                    <th>Passport Issue Country</th>
                                    <!--                              <th>Passenger Type</th>-->
                                    <th>Gender</th>
                                    <th>Nationality</th>
                                    <th>Base Fare</th>
                                    <th>Total Tax</th>
                                    <th>Gross Fare</th>
                                    <th>Ait</th>
                                    <th>Markup</th>
                                    <th>Commission</th>
                                    <th>Invoice Fare</th>
                                    <th>Ticket No.</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(passenger,index) in passengers" v-bind:key="index">
                                    <th>{{index+1}}</th>
                                    <td>
                                        <div>
                                            {{passenger.prefix}} {{passenger.first_name}} {{passenger.last_name}}
                                        </div>
                                        <div>
                                            {{passenger.passenger_type}}
                                        </div>
                                    </td>
                                    <td>{{passenger.date_of_birth |  moment('ll')}}</td>
                                    <td>{{passenger.passport_no==null ? 'N/A' : passenger.passport_no}}</td>
                                    <td>{{passenger.passport_expiry_date==null ? 'N/A' : passenger.passport_expiry_date|  moment('ll')}}</td>
                                    <td>{{passenger.passport_issue_country==null ? 'N/A' : passenger.passport_issue_country}}</td>
                                    <!--                              <td></td>-->
                                    <td>{{passenger.gender}}</td>
                                    <td>{{passenger.nationality}}</td>
                                    <td>{{passenger.base_fare}}</td>
                                    <td>{{passenger.total_tax}}</td>
                                    <td>{{passenger.gross_fare}}</td>
                                    <td>{{passenger.ait}}</td>
                                    <td>{{passenger.markup}}</td>
                                    <td>{{passenger.commission}}</td>
                                    <td>{{passenger.invoice_fare}}</td>
                                    <td>{{tickets[index]==null ? 'Not Confirmed' : tickets[index].ticket_no}}</td>
                                </tr>
                                </tbody>

                                <!--                                </tbody>-->
                            </table>
                        </div>
                        <!--                            </table>-->
                    </div>
                    <div class="d-print-none">
                        <div class="float-right">
                            <a @click.prevent="print(booking.id)" class="btn btn-success">
                                <i class="fa fa-print"></i>
                            </a>
                            <!--                      <button @click.prevent="sendMail(booking.id)" class="btn btn-primary w-md ml-1">Send Email</button>-->
                        </div>
                    </div>

                </b-modal>
                <div class="card">
                    <div class="card-body">
                        <div class="table-responsive table-responsive-sm">
                            <table class="table mb-0 table-striped">
                                <thead>
                                <tr>
                                    <th class="index-width">SL</th>
                                    <th class="booking-date-width">Booking /Travel Date</th>
                                    <th class="passengers-width">Passengers</th>
                                    <th>Book By</th>
                                    <th class="search-ref-key-index">Key</th>
                                    <th>
                                        <div>API/Airline Pnr/</div>
                                        <div>Routes/Trip Type</div>
                                    </th>
                                    <th>
                                        <div class="row">
                                            Gross Fare/
                                        </div>
                                        <div class="row">
                                            Ait/
                                        </div>
                                        <div class="row">
                                            Markup
                                        </div>

                                    </th>
                                    <th>
                                        <div class="row">
                                            Commission/
                                        </div>
                                        <div class="row">
                                            Invoice fare/
                                        </div>
                                        <div class="row">
                                            Currency
                                        </div>
                                    </th>
                                    <th class="booking-status-width">Booking/ Payment Status</th>
                                    <th class="action-index">Action</th>
                                </tr>
                                <tr>
                                    <td> &nbsp </td>
                                    <td> &nbsp </td>
                                    <td> &nbsp </td>
                                    <td><input type="text" class="app-search form-control" v-model="search_uname" placeholder="Username" /></td>
                                    <td><input type="text" class="app-search form-control" v-model="search1" placeholder="key" /></td>
                                    <td><input type="text" class="app-search form-control" v-model="search_pnr" placeholder="Pnr" /></td>

                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(booking,index) in filteredList"  v-bind:key="index">
                                    <th scope="row">{{index+1}}</th>
                                    <td>
                                        <div class="row">
                                            <div class="col-xs-4">{{booking.created_at|  moment("D MMM YYYY, H:mm")}}</div>
                                        </div>
                                        <div class="row">
                                            <div class="col-xs-4">{{booking.travel_date==null?'N/A':booking.travel_date|  moment("D MMM YYYY, H:mm")}}</div>
                                        </div>
                                    </td>
                                    <td>
                                        <div  v-for="(passeneger,index) in booking.passenger_info['name']">
                                            <div class="col-xs-4">{{passeneger}}</div>
                                        </div>
                                        <div  v-for="(passport,index) in booking.passenger_info['passport']">
                                            <div v-if="passport !='N/A'" class="col-xs-4">{{passport}}</div>
                                        </div>
                                    </td>
                                    <td v-if="booking.username!=null">
                                        <div v-if="booking.account_type==='b2b'" class="row">
                                            <div v-if="booking.username!=null" class="col-xs-4">{{booking.agency_name}}</div>
                                        </div>
                                        <div v-if="booking.account_type==='b2c'" class="row">
                                            <div v-if="booking.username!=null" class="col-xs-4">{{booking.user_name+"("+booking.account_type+")"}}</div>
                                        </div>
                                        <div class="row">
                                            <div class="col-xs-4"><router-link  :to="{ name: 'admin_agent_details', params: {id: booking.user_id } }" target="_blank" >{{booking.username==null ? 'N/A' : booking.username}}</router-link></div>
                                        </div>
                                    </td>
                                    <td v-else>N/A</td>
                                    <td><a href="" v-b-modal.modal-xl  @click.prevent="getBookingDetail(booking.id)">{{booking.search_reference_key}}</a></td>

                                    <td>
                                        <div class="row">
                                            <div class="col-xs-4">{{booking.api_vendor_name+"-"+booking.api_pnr}}</div>
                                        </div>
                                        <div class="row">
                                            <div class="col-xs-4">{{booking.airline+"-"+booking.airline_pnr}}</div>
                                        </div>
                                        <div class="row">
                                            <div class="col-xs-4">{{booking.flight_segments}}</div>
                                        </div>
                                        <div class="row">
                                            <div class="col-xs-4">{{booking.trip_type}}</div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="row">
                                            <div class="col-xs-4">{{booking.gross_fare}}</div>
                                        </div>
                                        <div class="row">
                                            <div class="col-xs-4">{{booking.ait==null ? 'N/A' :booking.ait}} </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-xs-4">{{booking.markup=null ? 'N/A' : booking.markup}}</div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="row">
                                            <div class="col-xs-4">{{booking.commission==null ? 'N/A' :booking.commission}} </div>
                                        </div>
                                        <div class="row">
                                            <b-badge variant="info" class="ml-1">{{booking.invoice_fare==null ? 'N/A' :booking.invoice_fare}}</b-badge>
                                        </div>
                                        <div class="row">
                                            <div class="col-xs-4">{{booking.currency==null ? 'N/A' :booking.currency}} </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="row">
                                            <b-badge v-if="booking.payment_status=='full-paid'" variant="success" class="ml-1">{{booking.payment_status}}</b-badge>
                                            <b-badge v-else-if="booking.payment_status=='partially-paid'" variant="primary" class="ml-1">{{booking.payment_status}}</b-badge>
                                            <b-badge v-else-if="booking.payment_status=='unpaid'" variant="danger" class="ml-1">{{booking.payment_status}}</b-badge>
                                            <b-badge v-else variant="dark" class="ml-1">{{booking.payment_status}}</b-badge>
                                        </div>
                                    </td>
                                    <td><router-link :to="{ name: 'flight_booking_update', params: {id: booking.id ,is_ticketing:true} }" class="btn btn-primary btn-sm"><i class="fas fa-edit"></i> Edit</router-link> </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- end row -->
    </Layout>
</template>
